import React from 'react';
import Link from 'next/link';
import { Box, Typography } from '@mui/material';
interface DocumentItemProps {
  title: string;
  link: string;
  lastItem?: boolean;
  index: number;
  type: 'file' | 'link';
}
const DocumentItem = ({
  title,
  link,
  lastItem,
  type
}: DocumentItemProps) => {
  const titleTag = type === 'file' ? 'دانلود فایل' : 'لینک';
  return <Box sx={{
    display: 'flex',
    flexDirection: 'row',
    bgcolor: {
      xs: 'unset',
      md: 'background.bg3'
    },
    borderBottom: {
      xs: !lastItem ? '1px solid' : 'unset',
      md: 'unset'
    },
    borderColor: {
      xs: !lastItem ? 'stroke.stroke2' : 'unset'
    },
    borderRadius: {
      md: 'var(--corner_radius_m)'
    },
    gap: 'var(--spacing_xs)',
    p: {
      xs: 'var(--spacing_s)',
      md: 'var(--spacing_m)'
    }
  }} data-sentry-element="Box" data-sentry-component="DocumentItem" data-sentry-source-file="DocumentItem.tsx">
      <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: 'var(--spacing_xs)',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    }} data-sentry-element="Box" data-sentry-source-file="DocumentItem.tsx">
        <Typography sx={{
        typography: {
          xs: 'captionMedium__Wallfund',
          md: 'captionMedium__Wallfund'
        }
      }} color='text.text2' data-sentry-element="Typography" data-sentry-source-file="DocumentItem.tsx">
          {title}
        </Typography>

        <Typography component={Link} sx={{
        typography: {
          xs: 'captionMedium__Wallfund',
          md: 'captionMedium__Wallfund'
        },
        color: {
          md: 'text.text',
          xs: 'text.text'
        }
      }} href={link} target='_blank' data-sentry-element="Typography" data-sentry-source-file="DocumentItem.tsx">
          {titleTag}
        </Typography>
      </Box>
    </Box>;
};
export default DocumentItem;